import type { IconData } from '@stacksjs/iconify-core'

export const visualBlindFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" fill-rule=\"evenodd\" d=\"M.855 22.698C3.61 12.781 12.703 5.5 23.5 5.5c10.798 0 19.89 7.28 22.645 17.198a4.87 4.87 0 0 1 0 2.604C43.391 35.219 34.298 42.5 23.5 42.5S3.61 35.22.855 25.302a4.87 4.87 0 0 1 0-2.604\" clip-rule=\"evenodd\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M23.5 34c5.523 0 10-4.477 10-10s-4.477-10-10-10s-10 4.477-10 10s4.477 10 10 10\" clip-rule=\"evenodd\"/><path fill=\"#8fbffa\" d=\"M20.914 18.586a2 2 0 1 0-2.828 2.828L20.672 24l-2.586 2.586a2 2 0 1 0 2.828 2.828l2.586-2.586l2.586 2.586a2 2 0 1 0 2.828-2.828L26.328 24l2.586-2.586a2 2 0 1 0-2.828-2.828L23.5 21.172z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default visualBlindFlat
